import DefaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

let erTag = DefaultAnalyticsConfig.erTag;
if (process.env.ENV === "production") {
  erTag = "70038ac860794dfc9077354f02765940";
}

export default class analyticsConfig extends DefaultAnalyticsConfig {
  static gaTag = "UA-25403594";
  static erTag = erTag;
  static cmp = {
    hasPreferenceView: true,
    accountId: 348,
    privacyManagerId: 780854,
    propertyId: 30435,
    wrapperMessaging:
      "https://sp-consent.insuedthueringen.de/unified/wrapperMessagingWithoutDetection.js",
    mmsDomain: "https://zeitung.insuedthueringen.de",
    baseEndpoint: "https://sp-consent.insuedthueringen.de",
    features: {
      ER: true,
      GA: true,
    },
    GA: {
      vendorId: "5e542b3a4cd8884eb41b5a72",
      purposeId: ["60ae3dfb2022f823f6c23a68", "60ae3dfb2022f823f6c23a71"],
    },
    ER: {
      vendorId: "5fa53d170b50cd88f2e54dcf",
      purposeId: ["6818b0372fbf261deb44de74"],
    },
    siteId: 780854,
  };

  static weekliOptions = {
    key: "1A5311F4-91BA-420B-9DC5-203E00340AA6",
    slot: 501,
    ID: 501,
    config: 1539,
    host: "epaper-insuedthueringen.weekli.de",
  };
}



// WEBPACK FOOTER //
// ./clients/swmh-ist/js/analyticsConfig.js